import React, { useEffect, useState } from 'react'
import { Link, Navigate, useParams } from 'react-router-dom'
import { eventService } from '../../../services/event.service'
import { reservationService } from '../../../services/reservation.service'
import { useGeneralApp } from '../../../hooks/useGeneralApp'
import JSPDF from 'jspdf'
import './styles.scss'
import dinorechazado from '../../../assets/gif/dinodeadfinald.gif'

export const RegisteredAttendancePage = () => {
  const { isLoading, setIsLoading } = useGeneralApp()
  const [event, setEvent] = useState({})
  const [qrImage, setQrImage] = useState('default')
  const { idEvento } = useParams()
  const gif = ''
  useEffect(() => {
    const getDataReservation = async () => {
      try {
        const dbEvent = await eventService.getOneEvent(idEvento)
        console.log(dbEvent)
        setEvent(dbEvent)
      } catch (error) {
        console.log(error.response.status)
        setEvent(null)
      }
    }

    getDataReservation()
  }, [])

  useEffect(() => {
    const getQR = async () => {
      try {
        const QR_CODE = await reservationService.getReservationQrByIdEventIdUser(idEvento)
        setQrImage(QR_CODE.codigo_qr)
      } catch (error) {
        console.log(error)
        setQrImage('https://www.ngenespanol.com/wp-content/uploads/2018/08/La-primera-imagen-de-la-historia-1280x720.jpg')
      }
    }

    getQR()
  }, [])

  if (event === null) {
    return <Navigate to="/recurso-no-encontrado" />
  }

  const handlerDownloadQR = () => {
    try {
      setIsLoading(true)
      const doc = new JSPDF('p', 'pt')
      doc.text(200, 200, `Tu codigo QR, evento: ${event.nombre_evento}`)
      doc.addImage(qrImage, 'JPEG', 250, 250)
      doc.save(`${event.nombre_evento}`)
      setIsLoading(false)
    } catch (error) {
      console.log(error)
      setIsLoading(false)
    }
  }
  return (
    <div className='layout' >
      <div className= 'container'>
        <div className = 'left-container'>
        <img src={dinorechazado} className='class="img-fluid"' alt="RAARR" />
        </div>
        <div className = 'right-container'>
          <h1 className= 'title'>¡Has reservado el evento!</h1>
          <div className='qr'></div>
          <p className= 'text'>Tu boleto está seguro con nosotros </p>
          <p className='text2'> Dos horas antes del evento lo podrás consultar aquí</p>
            <Link to='/mi-cuenta/reservaciones' className="button">
              <i className="bx bx-home-alt= me-2 ms-n1 lead" />
              Ver tus reservaciones
            </Link>
        </div>
      </div>
    </div>

  )
}
